import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { CompanyActionMenu } from "./CompanyActionMenu";

export const getCompanyDefaultValues = () => ({
  subscriptionId: 1,
  emailId: "",
  name: "",
  address: {
    street: "",
    houseNumber: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
  },
  active: true,
  paymentConfirmationNo: "card",
  rootUser: "",
  comments: "",
  validUntil: "",
  locationLongitude: "",
  locationLatitude: "",
  paymentCurrency: acceptableCurrencyList[0]?.value || "",
  paymentGatewayId: "",
  paymentGatewayDetailsId: 0,
  transactionPercent: "",
  taxPercent: "",
  provider: {
    name: "AMIK Technologies",
    redIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/red/amik.png",
    greenIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/green/amik.png",
    icon: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/amik.png",
    greyIcon:
      "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/grey/amik.png",
    countryCode: "+91",
  },
  companyProtocolType: "ocpp",
  token: "",
  endpoint: "",
  partyId: "",
  domain: "amiktechnologies",
});

export const acceptableCurrencyList = [
  { value: "INR", title: "Indian Rupees" },
  { value: "CAD", title: "Canadian Dollars" },
];

export const companyListColumns = (isReadOnly) => [
  {
    field: "name",
    headerName: "Name",
    width: 150,
    renderCell: ({ value, id }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "companyProtocolType",
    headerName: "Protocol Type",
    width: 120,
    valueFormatter: ({ value }) => value?.toUpperCase() || "OCPP",
  },
  {
    field: "creationTime",
    headerName: "Creation Time",
    width: 180,
    type: "date",
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "createdBy",
    headerName: "Created By",
    width: 120,
  },
  {
    field: "Actions",
    width: 70,
    sortable: false,
    renderCell: ({ id, row }) => {
      return <CompanyActionMenu id={id} row={row} />;
    },
  },
];
